import React, { useEffect, useId, useState } from 'react';
import { EMPTY_CONTENT_FILTERS } from './useContentList';
import './ContentFilters.scss';

export default function ContentFilters({ filters, onApply, loading, totalCount }) {
  const [draft, setDraft] = useState(filters);
  const [validationError, setValidationError] = useState('');
  const id = useId();
  useEffect(() => { setDraft(filters); setValidationError(''); }, [filters]);
  const update = (event) => setDraft((current) => ({ ...current, [event.target.name]: event.target.value }));
  useEffect(() => {
    if (['searchTerm', 'startDate', 'endDate', 'sortBy'].every((key) => draft[key] === filters[key])) {
      setValidationError('');
      return;
    }
    const timer = setTimeout(() => {
      if (draft.startDate && draft.endDate && draft.startDate > draft.endDate) {
        setValidationError('Başlangıç tarihi bitiş tarihinden sonra olamaz.');
        return;
      }
      setValidationError('');
      onApply({ ...draft, searchField: 'all' });
    }, 1000);
    return () => clearTimeout(timer);
  }, [draft, filters, onApply]);
  return (
    <section className="content-filters" aria-label="Kayıt filtreleri">
      <form onSubmit={(event) => event.preventDefault()}>
        <div className="content-filter-fields">
          <div className="content-filter-search">
            <label htmlFor={`${id}-query`}>Aranacak metin</label>
            <input id={`${id}-query`} name="searchTerm" type="search" className="form-control" value={draft.searchTerm} onChange={update} placeholder="Başlık veya içerikte arayın…" />
          </div>
          <div>
            <label htmlFor={`${id}-start`}>Başlangıç tarihi</label>
            <input id={`${id}-start`} name="startDate" type="date" className="form-control" value={draft.startDate} onChange={update} />
          </div>
          <div>
            <label htmlFor={`${id}-end`}>Bitiş tarihi</label>
            <input id={`${id}-end`} name="endDate" type="date" className="form-control" value={draft.endDate} onChange={update} />
          </div>
          <div>
            <label htmlFor={`${id}-sort`}>Sıralama</label>
            <select id={`${id}-sort`} name="sortBy" className="form-select" value={draft.sortBy} onChange={update}>
              <option value="Date Desc">En yeni önce</option>
              <option value="Date Asc">En eski önce</option>
              <option value="Header Asc">Başlık A–Z</option>
              <option value="Header Desc">Başlık Z–A</option>
            </select>
          </div>
        </div>
        {validationError && <p className="content-filter-error" role="alert">{validationError}</p>}
        <div className="content-filter-actions">
          <button type="button" className="arc-btn arc-btn-secondary arc-btn-sm" onClick={() => {
            setDraft(EMPTY_CONTENT_FILTERS); setValidationError(''); onApply(EMPTY_CONTENT_FILTERS);
          }}>Temizle</button>
          <span role="status">{loading ? 'Kayıtlar yükleniyor…' : `${totalCount.toLocaleString('tr-TR')} kayıt bulundu`}</span>
        </div>
      </form>
    </section>
  );
}

export function ContentPagination({ page, pageSize, totalCount, loading, onPageChange, onPageSizeChange }) {
  const pages = Math.max(1, Math.ceil(totalCount / pageSize));
  return (
    <nav className="content-pagination" aria-label="Kayıt sayfaları">
      <label>Sayfa başına
        <select className="form-select" value={pageSize} onChange={(event) => onPageSizeChange(Number(event.target.value))}>
          {[25, 50, 100].map((size) => <option key={size} value={size}>{size}</option>)}
        </select>
      </label>
      <div>
        <button type="button" className="arc-btn arc-btn-secondary arc-btn-sm" disabled={loading || page <= 1} onClick={() => onPageChange(page - 1)}>Önceki</button>
        <span aria-live="polite">{page} / {pages}</span>
        <button type="button" className="arc-btn arc-btn-secondary arc-btn-sm" disabled={loading || page >= pages} onClick={() => onPageChange(page + 1)}>Sonraki</button>
      </div>
    </nav>
  );
}
